import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import authEN from '../locales/en/auth.json';
import chatEN from '../locales/en/chat.json';
import invoicesEN from '../locales/en/invoices.json';
import settingsEN from '../locales/en/settings.json';
import shipmentEN from '../locales/en/shipment.json';
import simulationEN from '../locales/en/simulation.json';
import translationEN from '../locales/en/translation.json';
import authJA from '../locales/ja/auth.json';
import chatJA from '../locales/ja/chat.json';
import invoicesJA from '../locales/ja/invoices.json';
import settingsJA from '../locales/ja/settings.json';
import shipmentJA from '../locales/ja/shipment.json';
import simulationJA from '../locales/ja/simulation.json';
import translationJA from '../locales/ja/translation.json';

const resources = {
  en: {
    auth: authEN,
    chat: chatEN,
    invoices: invoicesEN,
    settings: settingsEN,
    shipment: shipmentEN,
    simulation: simulationEN,
    translation: translationEN,
  },
  ja: {
    auth: authJA,
    chat: chatJA,
    invoices: invoicesJA,
    settings: settingsJA,
    shipment: shipmentJA,
    simulation: simulationJA,
    translation: translationJA,
  },
};

const options = {
  // order and from where user language should be detected
  order: ['localStorage', 'navigator'],

  lookupLocalStorage: 'i18nextLng',

  // cache user language on
  caches: ['localStorage'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: options,
    resources,
    fallbackLng: 'ja',
    returnEmptyString: false,
    parseMissingKeyHandler: (key) => `Translation for ${key} not found`,
    keySeparator: '.', // char to separate keys
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
